window.addEventListener('load', function() {
  $('.input-with-icon').each(function() {
    var $input = $(this).children('input');

    $(this)
      .children('.input-icon-gray-box')
      .click(function() {
        $input.datepicker('show');
      });
  });
});
